import React from 'react';

// Serves optimised, responsive previews for uploaded plan images (/api/files/*).
// Prefers WebP with a JPEG fallback, requests smaller widths on phones, and
// loads the main image first while deferring the rest. Falls back to a plain
// <img> for any non-uploaded (external) URL. Never affects the original upload.

const isFileUrl = (src) => typeof src === 'string' && src.includes('/api/files/');

const buildUrl = (src, w, fmt) => {
  const sep = src.includes('?') ? '&' : '?';
  let url = `${src}${sep}w=${w}`;
  if (fmt) url += `&fmt=${fmt}`;
  return url;
};

export const OptimizedImage = ({
  src,
  alt,
  className,
  widths = [640, 1024],
  sizes = '100vw',
  priority = false,
  width,
  height,
}) => {
  const common = {
    alt,
    className,
    width,
    height,
    decoding: 'async',
    loading: priority ? 'eager' : 'lazy',
    fetchPriority: priority ? 'high' : 'auto',
  };

  if (!isFileUrl(src)) {
    return <img src={src} {...common} />;
  }

  const maxW = widths[widths.length - 1];
  const webpSet = widths.map((w) => `${buildUrl(src, w, 'webp')} ${w}w`).join(', ');
  const jpegSet = widths.map((w) => `${buildUrl(src, w, 'jpeg')} ${w}w`).join(', ');

  return (
    <picture>
      <source type="image/webp" srcSet={webpSet} sizes={sizes} />
      <img src={buildUrl(src, maxW, 'jpeg')} srcSet={jpegSet} sizes={sizes} {...common} />
    </picture>
  );
};

export default OptimizedImage;
